module.exports = __webpack_public_path__ + "img/Female.a99dcb20.svg";